import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';

import imgIcon from '../assets/images/package_not_available.svg';
import { HeaderMenuLeft } from '../public/js/modules/header';
import Footer from '../public/js/modules/footer';
import { publicConstants } from '../public/js/modules/public-constants';

const texts = {
  generic: {
    title: (
      <>
        Uh-oh...<br/>
        Looks like you’re off the map.
      </>
    ),
    icon_src: imgIcon,
    subtitle: "The page you’re looking for either does not exist or has been moved.",
    text: (
      <>
        Please visit our&nbsp;
        <a href="/">Home page</a> or <a href="mailto:support@submittal.com">contact support</a> if you have any questions.
      </>
    )
  },
  package_lost: {
    title: "The package is no longer available.",
    subtitle: "It may have been deleted or had access withdrawn by the owner.",
    text: (
      <>
        Please contact the package owner or contact&nbsp;
        <a href="mailto:support@submittal.com">support</a> if you have any questions.
      </>
    )
  }
};

export function Block404(props) {
  let p = texts[props.mode] || texts.generic,
      d = texts.generic;

  return (
    <div className="block-404">
      <div className="block-404__inner">
        <div className="block-404__title">
          {props.title || p.title || d.title}
        </div>

        <img className="block-404__icon" src={props.icon_src || p.icon_src || d.icon_src} />

        <div className="block-404__subtitle">
          {props.subtitle || p.subtitle || d.subtitle}
        </div>

        <div className="block-404__text">
          {props.text || p.text || d.text}
        </div>
      </div>
    </div>
  );
}

export default function NotFound404(props) {
  let [burger, setBurger] = useState(false);

  const LinkWrp = _props => {
    if (props.layout404) return <a href={_props.to} className={_props.className || ''}>{_props.children}</a>
    return <Link to={_props.to} className={_props.className || ''}>{_props.children}</Link>
  }

  useEffect(() => {
    if ($(".layout-wrapper").length) $(".layout-wrapper")[0].classList.add('notFound404');
  }, []);

  const toggleBurger = () => {
    document.body.classList.toggle('overflow_hidden');
    setBurger(!burger);
  }

  return (
    <div className="layout public">
      <header className='header'>
        <a href='/home' className='header-logo'></a>
        <div className={`header-burger ${burger ? ' _open' : ''}`} id="b-header__mobile-menu" onClick={toggleBurger}>
          <div/><div/><div/>
        </div>
        <nav className='header-menu'>
          <HeaderMenuLeft page404/>
          <div className='header-menu_right'>
            <a href="tel:8887178665" className="_call">Call {publicConstants.phone}<span
              className="boldHack">Call {publicConstants.phone}</span></a>
            <a href="/contact" className='__btn'>Contact</a>
          </div>
        </nav>
      </header>
      <section className="b-section">
        <div className="b-section_wrapper collapsed vertical_expanded">
          <h1 className="h1 centered">Uh-oh... Looks like you’re off the map.</h1>
          <p className="centered">
            The page you’re looking for either does not exist or has been moved.
            Please go to our <LinkWrp to={props.layout404 ? "/" : "/app/dashboard"} className="underline">Home Page</LinkWrp> or <a href="mailto:support@submittal.com" className="underline">contact support</a> if you
            have any questions.
          </p>
          <div className="buttons centered">
            <LinkWrp to={props.layout404 ? "/" : "/app/dashboard"} className='__btn _black'>Go to Home Page</LinkWrp>
          </div>
          <br/><br/><br/>
        </div>
      </section>
      <Footer page404/>
    </div>
  );
}
